import { inject, Injectable } from '@angular/core';

import { CountryInfo } from '../interfaces/country-info.interface';
import { MaybeUndefined } from '../utils';
import { PhoneNumberService } from './phone-number.service';

@Injectable({ providedIn: 'root' })
export class CountriesService {
  private phoneNumberService: PhoneNumberService = inject(PhoneNumberService);

  private countries: CountryInfo[] = [
    { name: 'Afghanistan (‫افغانستان‬‎)', iso: 'AF' },
    { name: 'Åland Islands', iso: 'AX' },
    { name: 'Albania (Shqipëri)', iso: 'AL' },
    { name: 'Algeria (‫الجزائر‬‎)', iso: 'DZ' },
    { name: 'American Samoa', iso: 'AS' },
    { name: 'Andorra', iso: 'AD' },
    { name: 'Angola', iso: 'AO' },
    { name: 'Anguilla', iso: 'AI' },
    { name: 'Antigua and Barbuda', iso: 'AG' },
    { name: 'Argentina', iso: 'AR' },
    { name: 'Armenia (Հայաստան)', iso: 'AM' },
    { name: 'Aruba', iso: 'AW' },
    { name: 'Australia', iso: 'AU' },
    { name: 'Austria (Österreich)', iso: 'AT' },
    { name: 'Azerbaijan (Azərbaycan)', iso: 'AZ' },
    { name: 'Bahamas', iso: 'BS' },
    { name: 'Bahrain (‫البحرين‬‎)', iso: 'BH' },
    { name: 'Bangladesh (বাংলাদেশ)', iso: 'BD' },
    { name: 'Barbados', iso: 'BB' },
    { name: 'Belarus (Беларусь)', iso: 'BY' },
    { name: 'Belgium (België)', iso: 'BE' },
    { name: 'Belize', iso: 'BZ' },
    { name: 'Benin (Bénin)', iso: 'BJ' },
    { name: 'Bermuda', iso: 'BM' },
    { name: 'Bhutan (འབྲུག)', iso: 'BT' },
    { name: 'Bolivia', iso: 'BO' },
    { name: 'Bosnia and Herzegovina (Босна и Херцеговина)', iso: 'BA' },
    { name: 'Botswana', iso: 'BW' },
    { name: 'Brazil (Brasil)', iso: 'BR' },
    { name: 'British Antarctic Territory', iso: 'AQ' },
    { name: 'British Indian Ocean Territory', iso: 'IO' },
    { name: 'British Virgin Islands', iso: 'VG' },
    { name: 'Brunei', iso: 'BN' },
    { name: 'Bulgaria (България)', iso: 'BG' },
    { name: 'Burkina Faso', iso: 'BF' },
    { name: 'Burundi (Uburundi)', iso: 'BI' },
    { name: 'Cambodia (កម្ពុជា)', iso: 'KH' },
    { name: 'Cameroon (Cameroun)', iso: 'CM' },
    { name: 'Canada', iso: 'CA' },
    { name: 'Cape Verde (Kabu Verdi)', iso: 'CV' },
    { name: 'Caribbean Netherlands', iso: 'BQ' },
    { name: 'Cayman Islands', iso: 'KY' },
    { name: 'Central African Republic (République centrafricaine)', iso: 'CF' },
    { name: 'Chad (Tchad)', iso: 'TD' },
    { name: 'Chile', iso: 'CL' },
    { name: 'China (中国)', iso: 'CN' },
    { name: 'Christmas Island', iso: 'CX' },
    { name: 'Cocos (Keeling) Islands', iso: 'CC' },
    { name: 'Colombia', iso: 'CO' },
    { name: 'Comoros (‫جزر القمر‬‎)', iso: 'KM' },
    { name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', iso: 'CD' },
    { name: 'Congo (Brazzaville)', iso: 'CG' },
    { name: 'Cook Islands', iso: 'CK' },
    { name: 'Costa Rica', iso: 'CR' },
    { name: 'Côte d’Ivoire', iso: 'CI' },
    { name: 'Croatia (Hrvatska)', iso: 'HR' },
    { name: 'Cuba', iso: 'CU' },
    { name: 'Curaçao', iso: 'CW' },
    { name: 'Cyprus (Κύπρος)', iso: 'CY' },
    { name: 'Czech Republic (Česká republika)', iso: 'CZ' },
    { name: 'Denmark (Danmark)', iso: 'DK' },
    { name: 'Djibouti', iso: 'DJ' },
    { name: 'Dominica', iso: 'DM' },
    { name: 'Dominican Republic (República Dominicana)', iso: 'DO' },
    { name: 'East Timor', iso: 'TL' },
    { name: 'Ecuador', iso: 'EC' },
    { name: 'El Salvador', iso: 'SV' },
    { name: 'Egypt (‫مصر‬‎)', iso: 'EG' },
    { name: 'Equatorial Guinea', iso: 'GQ' },
    { name: 'Eritrea', iso: 'ER' },
    { name: 'Estonia (Eesti)', iso: 'EE' },
    { name: 'Ethiopia', iso: 'ET' },
    { name: 'Falkland Islands (Islas Malvinas)', iso: 'FK' },
    { name: 'Faroe Islands (Føroyar)', iso: 'FO' },
    { name: 'Fiji', iso: 'FJ' },
    { name: 'Finland (Suomi)', iso: 'FI' },
    { name: 'France', iso: 'FR' },
    { name: 'French Guiana (Guyane française)', iso: 'GF' },
    { name: 'French Polynesia (Polynésie française)', iso: 'PF' },
    { name: 'French Southern and Antarctic Territories', iso: 'TF' },
    { name: 'Gabon', iso: 'GA' },
    { name: 'Gambia', iso: 'GM' },
    { name: 'Georgia (საქართველო)', iso: 'GE' },
    { name: 'Germany (Deutschland)', iso: 'DE' },
    { name: 'Ghana (Gaana)', iso: 'GH' },
    { name: 'Gibraltar', iso: 'GI' },
    { name: 'Greece (Ελλάδα)', iso: 'GR' },
    { name: 'Greenland (Kalaallit Nunaat)', iso: 'GL' },
    { name: 'Grenada', iso: 'GD' },
    { name: 'Guadeloupe', iso: 'GP' },
    { name: 'Guam', iso: 'GU' },
    { name: 'Guatemala', iso: 'GT' },
    { name: 'Guernsey', iso: 'GG' },
    { name: 'Guinea (Guinée)', iso: 'GN' },
    { name: 'Guinea-Bissau (Guiné Bissau)', iso: 'GW' },
    { name: 'Guyana', iso: 'GY' },
    { name: 'Haiti', iso: 'HT' },
    { name: 'Heard and McDonald Islands', iso: 'HM' },
    { name: 'Honduras', iso: 'HN' },
    { name: 'Hong Kong (香港)', iso: 'HK' },
    { name: 'Hungary (Magyarország)', iso: 'HU' },
    { name: 'Iceland (Ísland)', iso: 'IS' },
    { name: 'India (भारत)', iso: 'IN' },
    { name: 'Indonesia', iso: 'ID' },
    { name: 'Iran (‫ایران‬‎)', iso: 'IR' },
    { name: 'Iraq (‫العراق‬‎)', iso: 'IQ' },
    { name: 'Ireland', iso: 'IE' },
    { name: 'Isle of Man', iso: 'IM' },
    { name: 'Israel (‫ישראל‬‎)', iso: 'IL' },
    { name: 'Italy (Italia)', iso: 'IT' },
    { name: 'Jamaica', iso: 'JM' },
    { name: 'Japan (日本)', iso: 'JP' },
    { name: 'Jersey', iso: 'JE' },
    { name: 'Jordan (‫الأردن‬‎)', iso: 'JO' },
    { name: 'Kazakhstan (Казахстан)', iso: 'KZ' },
    { name: 'Kenya', iso: 'KE' },
    { name: 'Kiribati', iso: 'KI' },
    { name: 'Kosovo', iso: 'XK' },
    { name: 'Kuwait (‫الكويت‬‎)', iso: 'KW' },
    { name: 'Kyrgyzstan (Кыргызстан)', iso: 'KG' },
    { name: 'Laos (ລາວ)', iso: 'LA' },
    { name: 'Latvia (Latvija)', iso: 'LV' },
    { name: 'Lebanon (‫لبنان‬‎)', iso: 'LB' },
    { name: 'Lesotho', iso: 'LS' },
    { name: 'Liberia', iso: 'LR' },
    { name: 'Libya (‫ليبيا‬‎)', iso: 'LY' },
    { name: 'Liechtenstein', iso: 'LI' },
    { name: 'Lithuania (Lietuva)', iso: 'LT' },
    { name: 'Luxembourg', iso: 'LU' },
    { name: 'Macau (澳門)', iso: 'MO' },
    { name: 'Macedonia', iso: 'MK' },
    { name: 'Madagascar (Madagasikara)', iso: 'MG' },
    { name: 'Malawi', iso: 'MW' },
    { name: 'Malaysia', iso: 'MY' },
    { name: 'Maldives', iso: 'MV' },
    { name: 'Mali', iso: 'ML' },
    { name: 'Malta', iso: 'MT' },
    { name: 'Marshall Islands', iso: 'MH' },
    { name: 'Martinique', iso: 'MQ' },
    { name: 'Mauritania (‫موريتانيا‬‎)', iso: 'MR' },
    { name: 'Mauritius (Moris)', iso: 'MU' },
    { name: 'Mayotte', iso: 'YT' },
    { name: 'Mexico (México)', iso: 'MX' },
    { name: 'Micronesia', iso: 'FM' },
    { name: 'Moldova (Republica Moldova)', iso: 'MD' },
    { name: 'Monaco', iso: 'MC' },
    { name: 'Mongolia (Монгол)', iso: 'MN' },
    { name: 'Montenegro (Crna Gora)', iso: 'ME' },
    { name: 'Montserrat', iso: 'MS' },
    { name: 'Morocco (‫المغرب‬‎)', iso: 'MA' },
    { name: 'Mozambique (Moçambique)', iso: 'MZ' },
    { name: 'Myanmar (Burma) (မြန်မာ)', iso: 'MM' },
    { name: 'Namibia (Namibië)', iso: 'NA' },
    { name: 'Nauru', iso: 'NR' },
    { name: 'Nepal (नेपाल)', iso: 'NP' },
    { name: 'Netherlands (Nederland)', iso: 'NL' },
    { name: 'New Caledonia (Nouvelle-Calédonie)', iso: 'NC' },
    { name: 'New Zealand', iso: 'NZ' },
    { name: 'Nicaragua', iso: 'NI' },
    { name: 'Niger (Nijar)', iso: 'NE' },
    { name: 'Nigeria', iso: 'NG' },
    { name: 'Niue', iso: 'NU' },
    { name: 'Norfolk Island', iso: 'NF' },
    { name: 'North Korea (조선 민주주의 인민 공화국)', iso: 'KP' },
    { name: 'Northern Mariana Islands', iso: 'MP' },
    { name: 'Norway (Norge)', iso: 'NO' },
    { name: 'Oman (‫عُمان‬‎)', iso: 'OM' },
    { name: 'Pakistan (‫پاکستان‬‎)', iso: 'PK' },
    { name: 'Palau', iso: 'PW' },
    { name: 'Palestine (‫فلسطين‬‎)', iso: 'PS' },
    { name: 'Panama (Panamá)', iso: 'PA' },
    { name: 'Papua New Guinea', iso: 'PG' },
    { name: 'Paraguay', iso: 'PY' },
    { name: 'Peru (Perú)', iso: 'PE' },
    { name: 'Philippines', iso: 'PH' },
    { name: 'Pitcairn Islands', iso: 'PN' },
    { name: 'Poland (Polska)', iso: 'PL' },
    { name: 'Portugal', iso: 'PT' },
    { name: 'Puerto Rico', iso: 'PR' },
    { name: 'Qatar (‫قطر‬‎)', iso: 'QA' },
    { name: 'Réunion (La Réunion)', iso: 'RE' },
    { name: 'Romania (România)', iso: 'RO' },
    { name: 'Russia (Россия)', iso: 'RU' },
    { name: 'Rwanda', iso: 'RW' },
    { name: 'Saint Barthélemy (Saint-Barthélemy)', iso: 'BL' },
    { name: 'Saint Helena', iso: 'SH' },
    { name: 'Saint Kitts and Nevis', iso: 'KN' },
    { name: 'Saint Lucia', iso: 'LC' },
    { name: 'Saint Martin', iso: 'MF' },
    { name: 'Saint Pierre and Miquelon', iso: 'PM' },
    { name: 'Saint Vincent and the Grenadines', iso: 'VC' },
    { name: 'Samoa', iso: 'WS' },
    { name: 'San Marino', iso: 'SM' },
    { name: 'São Tomé and Príncipe', iso: 'ST' },
    { name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)', iso: 'SA' },
    { name: 'Senegal (Sénégal)', iso: 'SN' },
    { name: 'Serbia (Србија)', iso: 'RS' },
    { name: 'Seychelles', iso: 'SC' },
    { name: 'Sierra Leone', iso: 'SL' },
    { name: 'Sint Maarten', iso: 'SX' },
    { name: 'Singapore', iso: 'SG' },
    { name: 'Slovakia (Slovensko)', iso: 'SK' },
    { name: 'Slovenia (Slovenija)', iso: 'SI' },
    { name: 'Solomon Islands', iso: 'SB' },
    { name: 'Somalia (Soomaaliya)', iso: 'SO' },
    { name: 'South Africa', iso: 'ZA' },
    { name: 'South Korea', iso: 'KR' },
    { name: 'South Sudan (‫جنوب السودان‬‎)', iso: 'SS' },
    { name: 'Spain (España)', iso: 'ES' },
    { name: 'Sri Lanka (ශ්‍රී ලංකාව)', iso: 'LK' },
    { name: 'Sudan (‫السودان‬‎)', iso: 'SD' },
    { name: 'Suriname', iso: 'SR' },
    { name: 'Svalbard and Jan Mayen', iso: 'SJ' },
    { name: 'Swaziland', iso: 'SZ' },
    { name: 'Sweden (Sverige)', iso: 'SE' },
    { name: 'Switzerland (Schweiz)', iso: 'CH' },
    { name: 'Syria (‫سوريا‬‎)', iso: 'SY' },
    { name: 'Taiwan (台灣)', iso: 'TW' },
    { name: 'Tajikistan', iso: 'TJ' },
    { name: 'Tanzania', iso: 'TZ' },
    { name: 'Thailand (ไทย)', iso: 'TH' },
    { name: 'Togo', iso: 'TG' },
    { name: 'Tokelau', iso: 'TK' },
    { name: 'Tonga', iso: 'TO' },
    { name: 'Trinidad and Tobago', iso: 'TT' },
    { name: 'Tunisia (‫تونس‬‎)', iso: 'TN' },
    { name: 'Turkey (Türkiye)', iso: 'TR' },
    { name: 'Turkmenistan', iso: 'TM' },
    { name: 'Turks and Caicos Islands', iso: 'TC' },
    { name: 'Tuvalu', iso: 'TV' },
    { name: 'Uganda', iso: 'UG' },
    { name: 'Ukraine (Україна)', iso: 'UA' },
    { name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', iso: 'AE' },
    { name: 'United Kingdom', iso: 'GB' },
    { name: 'United States of America', iso: 'US' },
    { name: 'United States Minor Outlying Islands', iso: 'UM' },
    { name: 'Uruguay', iso: 'UY' },
    { name: 'U.S. Virgin Islands', iso: 'VI' },
    { name: 'Uzbekistan (Oʻzbekiston)', iso: 'UZ' },
    { name: 'Vanuatu', iso: 'VU' },
    { name: 'Vatican (Città del Vaticano)', iso: 'VA' },
    { name: 'Venezuela', iso: 'VE' },
    { name: 'Vietnam (Việt Nam)', iso: 'VN' },
    { name: 'Wallis and Futuna', iso: 'WF' },
    { name: 'Yemen (‫اليمن‬‎)', iso: 'YE' },
    { name: 'Zambia', iso: 'ZM' },
    { name: 'Zimbabwe', iso: 'ZW' },
  ];

  public getAllCountriesInfo(): CountryInfo[] {
    return this.countries;
  }

  public getCountriesName(): string[] {
    return this.countries.map((country: CountryInfo) => country.name);
  }

  public getCountry(name: string): MaybeUndefined<CountryInfo> {
    return this.countries.find((country: CountryInfo) => country.name === name);
  }

  public getCountryByName(name: string): string {
    return this.getCountry(name)?.iso ?? '';
  }

  public setupCountryInfo(): void {
    this.phoneNumberService.setupCountryPhoneInfo(this.countries);
  }
}
